import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { auth, sendPasswordReset } from "../firebase";
import "../styles/style.css";
import TextField from "@mui/material/TextField";
import NavbarLanding from "../components/Navbar/NavbarLanding";

function Reset() {
  const [email, setEmail] = useState("");
  const [user, loading, error] = useAuthState(auth);
  const navigate = useNavigate();
  useEffect(() => {
    if (loading) return;
    if (user) navigate("/dashboard");
  }, [user, loading]);
  return (
    <div className="background no-overflow">
      <NavbarLanding />
        <div className="container-index container--middle reset--container">
        <div className="login-header">
          <h3>
            Please enter your email address to receive a password reset link.
          </h3>
          <div className="login_container">
            <TextField
              fullWidth
              id="outlined-textarea"
              className="login_textBox"
              label="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              size="normal"
              margin="normal"
              multiline
            />
            <br />
            <button
              className="login_btn"
              onClick={() => sendPasswordReset(email)}
            >
              Send password reset email
            </button>
            <br />
            <div className="login-btn-divider"></div>
          </div>
        </div>
        </div>
    </div>
  );
}
export default Reset;
